import { GetState, ReduxAction, ThunkDispatchType } from 'app/redux/types';

import { StakeType } from 'app/lib/staking/constants';

import { selectAmountStakeType, selectCurrentStakeType } from '../selectors/stakeTypes';
import { selectSingleAmountModifier, selectSingleBetsInfo } from '../selectors/stakeTypes/single';
import { selectSystemAmountModifier } from '../selectors/stakeTypes/system';
import {
  ChangeStakeTypeAction,
  createChangeStakeTypeAmountFactory,
} from '../utils/stake-types-actions';
import { ChangeEntryAmount, changeEntryAmount } from './entries';

// ---


export const CHANGE_STAKE_TYPE_AMOUNT = 'BET_SLIP:CHANGE_STAKE_TYPE_AMOUNT';

export type ChangeStakeTypeAmount = ChangeStakeTypeAction<typeof CHANGE_STAKE_TYPE_AMOUNT>;

export const changeStakeTypeAmount = createChangeStakeTypeAmountFactory(CHANGE_STAKE_TYPE_AMOUNT);

// ---

export type PickPresetAmount =
  | ChangeEntryAmount
  | ChangeStakeTypeAmount;

type PickPresetAmountAction = (
  dispatch: ThunkDispatchType<PickPresetAmount>,
  getState: GetState,
) => void;

export const pickPresetAmount = (value: number, betId?: number): PickPresetAmountAction => (
  (dispatch, getState) => {
    const state = getState();

    const stringValue = value.toString(10);

    if (betId) {
      const info = selectSingleBetsInfo(state).get(betId);
      const account = info?.amount?.account;

      if (!account) {
        return;
      }

      return dispatch(changeEntryAmount(betId, stringValue, account));
    }

    const activeStakeType = selectCurrentStakeType(state);
    const amount = selectAmountStakeType(state);

    switch (activeStakeType.first()) {
      case StakeType.SINGLE: {
        const modifier = selectSingleAmountModifier(state);

        return dispatch(changeStakeTypeAmount(stringValue, amount.account, modifier));
      }

      case StakeType.EXPRESS: {
        return dispatch(changeStakeTypeAmount(stringValue, amount.account));
      }

      case StakeType.SYSTEM: {
        const modifier = selectSystemAmountModifier(state);

        return dispatch(changeStakeTypeAmount(stringValue, amount.account, modifier));
      }

      default:
        console.error(`pickPresetAmount -> unrecognized activeStakeType = ${activeStakeType}`);
    }
  }
);

// ---

export const UPDATE_CHECKED_STAKE_TYPE = 'BET_SLIP:UPDATE_CHECKED_STAKE_TYPE';

export type UpdateCheckedStakeType = ReduxAction<typeof UPDATE_CHECKED_STAKE_TYPE, {
  value: StakeType;
}>;

export const updateCheckedStakeType = (value: StakeType): UpdateCheckedStakeType => ({
  type: UPDATE_CHECKED_STAKE_TYPE,
  payload: { value },
});
